import { render, staticRenderFns } from "./averageVotes.vue?vue&type=template&id=f75e0828&scoped=true&"
import script from "./averageVotes.vue?vue&type=script&lang=js&"
export * from "./averageVotes.vue?vue&type=script&lang=js&"
import style0 from "./averageVotes.vue?vue&type=style&index=0&id=f75e0828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75e0828",
  null
  
)

export default component.exports